import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { v4 as uuidv4 } from 'uuid'

import { useAppDispatch } from '../../../data/store'
import { getActiveClientMessengerId } from '../data/messagesSelectors'
import { setActiveClientMessengerId } from '../data/messagesSlice'

// Client-page chat surfaces share one Redux conversation selection. Claim it before
// mounting a messenger, including when keyboard activation opens another surface.
export const useClientMessenger = (onClose: () => void) => {
  const [id] = useState(() => uuidv4())
  const [hasClaimed, setHasClaimed] = useState(false)
  const activeId = useSelector(getActiveClientMessengerId)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveClientMessengerId(id))
    setHasClaimed(true)
    return () => {
      dispatch((dispatch, getState) => {
        if (getActiveClientMessengerId(getState()) === id) dispatch(setActiveClientMessengerId(null))
      })
    }
  }, [dispatch, id])

  useEffect(() => {
    if (hasClaimed && activeId !== id) onClose()
  }, [activeId, hasClaimed, id, onClose])

  return hasClaimed && activeId === id
}
